<script>
	// NPM Modules
	import dayjs from 'dayjs';
	import localizedFormat from 'dayjs/plugin/localizedFormat';
	// Services
	import { NumberFormat, covertSecondsToDisplayString } from '@/Services/Helpers.js';

	dayjs.extend(localizedFormat);

	export let user;
</script>

<div class="flex flex-col md:w-1/2 text-dark-grey bg-gray-50 min-h-48">
	<div class="flex items-center px-2 bg-dark-grey text-light">
		<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">Client Edge</h2>
	</div>
	<div class=" overflow-auto">
		<table class="table w-full overflow-y-auto bg-white">
			<tr class="text-sm text-left bg-grey text-light">
				<th class="py-2 pl-2" />
				<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">Today</th>
				<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">Last 2 days</th>
				<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">Last 7 days</th>
				<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">Last 30 days</th>
				<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">Last 90 days</th>
				<th class="py-2 italic w-28 text-nowrap px-1 md:px-0">Lifetime</th>
			</tr>
			{#if user.client_edge && user.client_edge.beat_the_price_racing}
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b px-2 font-semibold text-base text-nowrap"> Beat The Market - Racing </td>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_racing.today <= -10 &&
							user.client_edge.beat_the_price_racing.today !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_racing.today <= -5 &&
							user.client_edge.beat_the_price_racing.today >= -9.99 &&
							user.client_edge.beat_the_price_racing.today !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_racing.today <= -2 &&
							user.client_edge.beat_the_price_racing.today >= -4.99 &&
							user.client_edge.beat_the_price_racing.today !== null}
						class:bg-green-300={user.client_edge.beat_the_price_racing.today <= 4.99 &&
							user.client_edge.beat_the_price_racing.today >= -1.99 &&
							user.client_edge.beat_the_price_racing.today !== null}
						class:bg-green-500={user.client_edge.beat_the_price_racing.today >= 5 &&
							user.client_edge.beat_the_price_racing.today !== null}
						>{user.client_edge.beat_the_price_racing.today == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_racing.today, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_racing.last_2_days <= -10 &&
							user.client_edge.beat_the_price_racing.last_2_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_racing.last_2_days <= -5 &&
							user.client_edge.beat_the_price_racing.last_2_days >= -9.99 &&
							user.client_edge.beat_the_price_racing.last_2_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_racing.last_2_days <= -2 &&
							user.client_edge.beat_the_price_racing.last_2_days >= -4.99 &&
							user.client_edge.beat_the_price_racing.last_2_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_racing.last_2_days <= 4.99 &&
							user.client_edge.beat_the_price_racing.last_2_days >= -1.99 &&
							user.client_edge.beat_the_price_racing.last_2_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_racing.last_2_days >= 5 &&
							user.client_edge.beat_the_price_racing.last_2_days !== null}
						>{user.client_edge.beat_the_price_racing.last_2_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_racing.last_2_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_racing.last_7_days <= -10 &&
							user.client_edge.beat_the_price_racing.last_7_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_racing.last_7_days <= -5 &&
							user.client_edge.beat_the_price_racing.last_7_days >= -9.99 &&
							user.client_edge.beat_the_price_racing.last_7_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_racing.last_7_days <= -2 &&
							user.client_edge.beat_the_price_racing.last_7_days >= -4.99 &&
							user.client_edge.beat_the_price_racing.last_7_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_racing.last_7_days <= 4.99 &&
							user.client_edge.beat_the_price_racing.last_7_days >= -1.99 &&
							user.client_edge.beat_the_price_racing.last_7_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_racing.last_7_days >= 5 &&
							user.client_edge.beat_the_price_racing.last_7_days !== null}
						>{user.client_edge.beat_the_price_racing.last_7_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_racing.last_7_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_racing.last_30_days <= -10 &&
							user.client_edge.beat_the_price_racing.last_30_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_racing.last_30_days <= -5 &&
							user.client_edge.beat_the_price_racing.last_30_days >= -9.99 &&
							user.client_edge.beat_the_price_racing.last_30_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_racing.last_30_days <= -2 &&
							user.client_edge.beat_the_price_racing.last_30_days >= -4.99 &&
							user.client_edge.beat_the_price_racing.last_30_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_racing.last_30_days <= 4.99 &&
							user.client_edge.beat_the_price_racing.last_30_days >= -1.99 &&
							user.client_edge.beat_the_price_racing.last_30_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_racing.last_30_days >= 5 &&
							user.client_edge.beat_the_price_racing.last_30_days !== null}
						>{user.client_edge.beat_the_price_racing.last_30_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_racing.last_30_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_racing.last_90_days <= -10 &&
							user.client_edge.beat_the_price_racing.last_90_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_racing.last_90_days <= -5 &&
							user.client_edge.beat_the_price_racing.last_90_days >= -9.99 &&
							user.client_edge.beat_the_price_racing.last_90_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_racing.last_90_days <= -2 &&
							user.client_edge.beat_the_price_racing.last_90_days >= -4.99 &&
							user.client_edge.beat_the_price_racing.last_90_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_racing.last_90_days <= 4.99 &&
							user.client_edge.beat_the_price_racing.last_90_days >= -1.99 &&
							user.client_edge.beat_the_price_racing.last_90_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_racing.last_90_days >= 5 &&
							user.client_edge.beat_the_price_racing.last_90_days !== null}
						>{user.client_edge.beat_the_price_racing.last_90_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_racing.last_90_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_racing.lifetime <= -10 &&
							user.client_edge.beat_the_price_racing.lifetime !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_racing.lifetime <= -5 &&
							user.client_edge.beat_the_price_racing.lifetime >= -9.99 &&
							user.client_edge.beat_the_price_racing.lifetime !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_racing.lifetime <= -2 &&
							user.client_edge.beat_the_price_racing.lifetime >= -4.99 &&
							user.client_edge.beat_the_price_racing.lifetime !== null}
						class:bg-green-300={user.client_edge.beat_the_price_racing.lifetime <= 4.99 &&
							user.client_edge.beat_the_price_racing.lifetime >= -1.99 &&
							user.client_edge.beat_the_price_racing.lifetime !== null}
						class:bg-green-500={user.client_edge.beat_the_price_racing.lifetime >= 5 &&
							user.client_edge.beat_the_price_racing.lifetime !== null}
						>{user.client_edge.beat_the_price_racing.lifetime == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_racing.lifetime, true) + '%'}</td
					>
				</tr>
			{/if}
			{#if user.client_edge && user.client_edge.beat_the_price_sport}
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b px-2 font-semibold text-base text-nowrap"> Beat The Market - Sport </td>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_sport.today <= -10 &&
							user.client_edge.beat_the_price_sport.today !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_sport.today <= -2.49 &&
							user.client_edge.beat_the_price_sport.today >= -9.99 &&
							user.client_edge.beat_the_price_sport.today !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_sport.today <= 2.49 &&
							user.client_edge.beat_the_price_sport.today >= -2.5 &&
							user.client_edge.beat_the_price_sport.today !== null}
						class:bg-green-300={user.client_edge.beat_the_price_sport.today <= 9.99 &&
							user.client_edge.beat_the_price_sport.today >= 2.5 &&
							user.client_edge.beat_the_price_sport.today !== null}
						class:bg-green-500={user.client_edge.beat_the_price_sport.today >= 10 &&
							user.client_edge.beat_the_price_sport.today !== null}
						>{user.client_edge.beat_the_price_sport.today == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_sport.today, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_sport.last_2_days <= -10 &&
							user.client_edge.beat_the_price_sport.last_2_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_sport.last_2_days <= -2.49 &&
							user.client_edge.beat_the_price_sport.last_2_days >= -9.99 &&
							user.client_edge.beat_the_price_sport.last_2_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_sport.last_2_days <= 2.49 &&
							user.client_edge.beat_the_price_sport.last_2_days >= -2.5 &&
							user.client_edge.beat_the_price_sport.last_2_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_sport.last_2_days <= 9.99 &&
							user.client_edge.beat_the_price_sport.last_2_days >= 2.5 &&
							user.client_edge.beat_the_price_sport.last_2_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_sport.last_2_days >= 10 &&
							user.client_edge.beat_the_price_sport.last_2_days !== null}
						>{user.client_edge.beat_the_price_sport.last_2_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_sport.last_2_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_sport.last_7_days <= -10 &&
							user.client_edge.beat_the_price_sport.last_7_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_sport.last_7_days <= -2.49 &&
							user.client_edge.beat_the_price_sport.last_7_days >= -9.99 &&
							user.client_edge.beat_the_price_sport.last_7_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_sport.last_7_days <= 2.49 &&
							user.client_edge.beat_the_price_sport.last_7_days >= -2.5 &&
							user.client_edge.beat_the_price_sport.last_7_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_sport.last_7_days <= 9.99 &&
							user.client_edge.beat_the_price_sport.last_7_days >= 2.5 &&
							user.client_edge.beat_the_price_sport.last_7_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_sport.last_7_days >= 10 &&
							user.client_edge.beat_the_price_sport.last_7_days !== null}
						>{user.client_edge.beat_the_price_sport.last_7_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_sport.last_7_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_sport.last_30_days <= -10 &&
							user.client_edge.beat_the_price_sport.last_30_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_sport.last_30_days <= -2.49 &&
							user.client_edge.beat_the_price_sport.last_30_days >= -9.99 &&
							user.client_edge.beat_the_price_sport.todlast_30_daysay !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_sport.last_30_days <= 2.49 &&
							user.client_edge.beat_the_price_sport.last_30_days >= -2.5 &&
							user.client_edge.beat_the_price_sport.last_30_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_sport.last_30_days <= 9.99 &&
							user.client_edge.beat_the_price_sport.last_30_days >= 2.5 &&
							user.client_edge.beat_the_price_sport.last_30_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_sport.last_30_days >= 10 &&
							user.client_edge.beat_the_price_sport.last_30_days !== null}
						>{user.client_edge.beat_the_price_sport.last_30_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_sport.last_30_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_sport.last_90_days <= -10 &&
							user.client_edge.beat_the_price_sport.last_90_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_sport.last_90_days <= -2.49 &&
							user.client_edge.beat_the_price_sport.last_90_days - 9.99 &&
							user.client_edge.beat_the_price_sport.last_90_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_sport.last_90_days <= 2.49 &&
							user.client_edge.beat_the_price_sport.last_90_days >= -2.5 &&
							user.client_edge.beat_the_price_sport.last_90_days !== null}
						class:bg-green-300={user.client_edge.beat_the_price_sport.last_90_days <= 9.99 &&
							user.client_edge.beat_the_price_sport.last_90_days >= 2.5 &&
							user.client_edge.beat_the_price_sport.last_90_days !== null}
						class:bg-green-500={user.client_edge.beat_the_price_sport.last_90_days >= 10 &&
							user.client_edge.beat_the_price_sport.last_90_days !== null}
						>{user.client_edge.beat_the_price_sport.last_90_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_sport.last_90_days, true) + '%'}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_price_sport.lifetime <= -10 &&
							user.client_edge.beat_the_price_sport.lifetime !== null}
						class:bg-orange-400={user.client_edge.beat_the_price_sport.lifetime <= -2.49 &&
							user.client_edge.beat_the_price_sport.lifetime >= -9.99 &&
							user.client_edge.beat_the_price_sport.lifetime !== null}
						class:bg-yellow-400={user.client_edge.beat_the_price_sport.lifetime <= 2.49 &&
							user.client_edge.beat_the_price_sport.lifetime >= -2.5 &&
							user.client_edge.beat_the_price_sport.lifetime !== null}
						class:bg-green-300={user.client_edge.beat_the_price_sport.lifetime <= 9.99 &&
							user.client_edge.beat_the_price_sport.lifetime >= 2.5 &&
							user.client_edge.beat_the_price_sport.lifetime !== null}
						class:bg-green-500={user.client_edge.beat_the_price_sport.lifetime >= 10 &&
							user.client_edge.beat_the_price_sport.lifetime !== null}
						>{user.client_edge.beat_the_price_sport.lifetime == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_price_sport.lifetime, true) + '%'}</td
					>
				</tr>
			{/if}
			{#if user.client_edge && user.client_edge.beat_the_line}
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b px-2 font-semibold text-base text-nowrap"> Beat The Line - Sport </td>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_line.today <= -3 &&
							user.client_edge.beat_the_line.today !== null}
						class:bg-orange-400={user.client_edge.beat_the_line.today <= -0.99 &&
							user.client_edge.beat_the_line.today >= -2.99 &&
							user.client_edge.beat_the_line.today !== null}
						class:bg-yellow-400={user.client_edge.beat_the_line.today <= 0.99 &&
							user.client_edge.beat_the_line.today >= -1 &&
							user.client_edge.beat_the_line.today !== null}
						class:bg-green-300={user.client_edge.beat_the_line.today <= 2.99 &&
							user.client_edge.beat_the_line.today >= 1 &&
							user.client_edge.beat_the_line.today !== null}
						class:bg-green-500={user.client_edge.beat_the_line.today >= 3 &&
							user.client_edge.beat_the_line.today !== null}
						>{user.client_edge.beat_the_line.today == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_line.today, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_line.last_2_days <= -3 &&
							user.client_edge.beat_the_line.last_2_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_line.last_2_days <= -0.99 &&
							user.client_edge.beat_the_line.last_2_days >= -2.99 &&
							user.client_edge.beat_the_line.last_2_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_line.last_2_days <= 0.99 &&
							user.client_edge.beat_the_line.last_2_days >= -1 &&
							user.client_edge.beat_the_line.last_2_days !== null}
						class:bg-green-300={user.client_edge.beat_the_line.last_2_days <= 2.99 &&
							user.client_edge.beat_the_line.last_2_days >= 1 &&
							user.client_edge.beat_the_line.last_2_days !== null}
						class:bg-green-500={user.client_edge.beat_the_line.last_2_days >= 3 &&
							user.client_edge.beat_the_line.last_2_days !== null}
						>{user.client_edge.beat_the_line.last_2_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_line.last_2_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_line.last_7_days <= -3 &&
							user.client_edge.beat_the_line.last_7_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_line.last_7_days <= -0.99 &&
							user.client_edge.beat_the_line.last_7_days >= -2.99 &&
							user.client_edge.beat_the_line.last_7_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_line.last_7_days <= 0.99 &&
							user.client_edge.beat_the_line.last_7_days >= -1 &&
							user.client_edge.beat_the_line.last_7_days !== null}
						class:bg-green-300={user.client_edge.beat_the_line.last_7_days <= 2.99 &&
							user.client_edge.beat_the_line.last_7_days >= 1 &&
							user.client_edge.beat_the_line.last_7_days !== null}
						class:bg-green-500={user.client_edge.beat_the_line.last_7_days >= 3 &&
							user.client_edge.beat_the_line.last_7_days !== null}
						>{user.client_edge.beat_the_line.last_7_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_line.last_7_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_line.last_30_days <= -3 &&
							user.client_edge.beat_the_line.last_30_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_line.last_30_days <= -0.99 &&
							user.client_edge.beat_the_line.last_30_days >= -2.99 &&
							user.client_edge.beat_the_line.last_30_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_line.last_30_days <= 0.99 &&
							user.client_edge.beat_the_line.last_30_days >= -1 &&
							user.client_edge.beat_the_line.last_30_days !== null}
						class:bg-green-300={user.client_edge.beat_the_line.last_30_days <= 2.99 &&
							user.client_edge.beat_the_line.last_30_days >= 1 &&
							user.client_edge.beat_the_line.last_30_days !== null}
						class:bg-green-500={user.client_edge.beat_the_line.last_30_days >= 3 &&
							user.client_edge.beat_the_line.last_30_days !== null}
						>{user.client_edge.beat_the_line.last_30_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_line.last_30_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_line.last_90_days <= -3 &&
							user.client_edge.beat_the_line.last_90_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_line.last_90_days <= -0.99 &&
							user.client_edge.beat_the_line.last_90_days >= -2.99 &&
							user.client_edge.beat_the_line.last_90_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_line.last_90_days <= 0.99 &&
							user.client_edge.beat_the_line.last_90_days >= -1 &&
							user.client_edge.beat_the_line.last_90_days !== null}
						class:bg-green-300={user.client_edge.beat_the_line.last_90_days <= 2.99 &&
							user.client_edge.beat_the_line.last_90_days >= 1 &&
							user.client_edge.beat_the_line.last_90_days !== null}
						class:bg-green-500={user.client_edge.beat_the_line.last_90_days >= 3 &&
							user.client_edge.beat_the_line.last_90_days !== null}
						>{user.client_edge.beat_the_line.last_90_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_line.last_90_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_line.lifetime <= -3 &&
							user.client_edge.beat_the_line.lifetime !== null}
						class:bg-orange-400={user.client_edge.beat_the_line.lifetime <= -0.99 &&
							user.client_edge.beat_the_line.lifetime >= -2.99 &&
							user.client_edge.beat_the_line.lifetime !== null}
						class:bg-yellow-400={user.client_edge.beat_the_line.lifetime <= 0.99 &&
							user.client_edge.beat_the_line.lifetime >= -1 &&
							user.client_edge.beat_the_line.lifetime !== null}
						class:bg-green-300={user.client_edge.beat_the_line.lifetime <= 2.99 &&
							user.client_edge.beat_the_line.lifetime >= 1 &&
							user.client_edge.beat_the_line.lifetime !== null}
						class:bg-green-500={user.client_edge.beat_the_line.lifetime >= 3 &&
							user.client_edge.beat_the_line.lifetime !== null}
						>{user.client_edge.beat_the_line.lifetime == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_line.lifetime, true)}</td
					>
				</tr>
			{/if}
			{#if user.client_edge && user.client_edge.beat_the_total}
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b px-2 font-semibold text-base text-nowrap"> Beat The Total - Sport </td>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_total.today <= -3 &&
							user.client_edge.beat_the_total.today !== null}
						class:bg-orange-400={user.client_edge.beat_the_total.today <= -0.99 &&
							user.client_edge.beat_the_total.today >= -2.99 &&
							user.client_edge.beat_the_total.today !== null}
						class:bg-yellow-400={user.client_edge.beat_the_total.today <= 0.99 &&
							user.client_edge.beat_the_total.today >= -1 &&
							user.client_edge.beat_the_total.today !== null}
						class:bg-green-300={user.client_edge.beat_the_total.today <= 2.99 &&
							user.client_edge.beat_the_total.today >= 1 &&
							user.client_edge.beat_the_total.today !== null}
						class:bg-green-500={user.client_edge.beat_the_total.today >= 3 &&
							user.client_edge.beat_the_total.today !== null}
						>{user.client_edge.beat_the_total.today == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_total.today, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_total.last_2_days <= -3 &&
							user.client_edge.beat_the_total.last_2_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_total.last_2_days <= -0.99 &&
							user.client_edge.beat_the_total.last_2_days >= -2.99 &&
							user.client_edge.beat_the_total.last_2_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_total.last_2_days <= 0.99 &&
							user.client_edge.beat_the_total.last_2_days >= -1 &&
							user.client_edge.beat_the_total.last_2_days !== null}
						class:bg-green-300={user.client_edge.beat_the_total.last_2_days <= 2.99 &&
							user.client_edge.beat_the_total.last_2_days >= 1 &&
							user.client_edge.beat_the_total.last_2_days !== null}
						class:bg-green-500={user.client_edge.beat_the_total.last_2_days >= 3 &&
							user.client_edge.beat_the_total.last_2_days !== null}
						>{user.client_edge.beat_the_total.last_2_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_total.last_2_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_total.last_7_days <= -3 &&
							user.client_edge.beat_the_total.last_7_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_total.last_7_days <= -0.99 &&
							user.client_edge.beat_the_total.last_7_days >= -2.99 &&
							user.client_edge.beat_the_total.last_7_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_total.last_7_days <= 0.99 &&
							user.client_edge.beat_the_total.last_7_days >= -1 &&
							user.client_edge.beat_the_total.last_7_days !== null}
						class:bg-green-300={user.client_edge.beat_the_total.last_7_days <= 2.99 &&
							user.client_edge.beat_the_total.last_7_days >= 1 &&
							user.client_edge.beat_the_total.last_7_days !== null}
						class:bg-green-500={user.client_edge.beat_the_total.last_7_days >= 3 &&
							user.client_edge.beat_the_total.last_7_days !== null}
						>{user.client_edge.beat_the_total.last_7_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_total.last_7_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_total.last_30_days <= -3 &&
							user.client_edge.beat_the_total.last_30_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_total.last_30_days <= -0.99 &&
							user.client_edge.beat_the_total.last_30_days >= -2.99 &&
							user.client_edge.beat_the_total.last_30_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_total.last_30_days <= 0.99 &&
							user.client_edge.beat_the_total.last_30_days >= -1 &&
							user.client_edge.beat_the_total.last_30_days !== null}
						class:bg-green-300={user.client_edge.beat_the_total.last_30_days <= 2.99 &&
							user.client_edge.beat_the_total.last_30_days >= 1 &&
							user.client_edge.beat_the_total.last_30_days !== null}
						class:bg-green-500={user.client_edge.beat_the_total.last_30_days >= 3 &&
							user.client_edge.beat_the_total.last_30_days !== null}
						>{user.client_edge.beat_the_total.last_30_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_total.last_30_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_total.last_90_days <= -3 &&
							user.client_edge.beat_the_total.last_90_days !== null}
						class:bg-orange-400={user.client_edge.beat_the_total.last_90_days <= -0.99 &&
							user.client_edge.beat_the_total.last_90_days >= -2.99 &&
							user.client_edge.beat_the_total.last_90_days !== null}
						class:bg-yellow-400={user.client_edge.beat_the_total.last_90_days <= 0.99 &&
							user.client_edge.beat_the_total.last_90_days >= -1 &&
							user.client_edge.beat_the_total.last_90_days !== null}
						class:bg-green-300={user.client_edge.beat_the_total.last_90_days <= 2.99 &&
							user.client_edge.beat_the_total.last_90_days >= 1 &&
							user.client_edge.beat_the_total.last_90_days !== null}
						class:bg-green-500={user.client_edge.beat_the_total.last_90_days >= 3 &&
							user.client_edge.beat_the_total.last_90_days !== null}
						>{user.client_edge.beat_the_total.last_90_days == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_total.last_90_days, true)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.beat_the_total.lifetime <= -3 &&
							user.client_edge.beat_the_total.lifetime !== null}
						class:bg-orange-400={user.client_edge.beat_the_total.lifetime <= -0.99 &&
							user.client_edge.beat_the_total.lifetime >= -2.99 &&
							user.client_edge.beat_the_total.lifetime !== null}
						class:bg-yellow-400={user.client_edge.beat_the_total.lifetime <= 0.99 &&
							user.client_edge.beat_the_total.lifetime >= -1 &&
							user.client_edge.beat_the_total.lifetime !== null}
						class:bg-green-300={user.client_edge.beat_the_total.lifetime <= 2.99 &&
							user.client_edge.beat_the_total.lifetime >= 1 &&
							user.client_edge.beat_the_total.lifetime !== null}
						class:bg-green-500={user.client_edge.beat_the_total.lifetime >= 3 &&
							user.client_edge.beat_the_total.lifetime !== null}
						>{user.client_edge.beat_the_total.lifetime == null
							? '-'
							: NumberFormat(user.client_edge.beat_the_total.lifetime, true)}</td
					>
				</tr>
			{/if}
			{#if user.client_edge && user.client_edge.time_before_jump_racing}
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b px-2 font-semibold text-base text-nowrap"> Time Before Jump - Racing </td>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_jump_racing.today >= 172860 &&
							user.client_edge.time_before_jump_racing.today !== null}
						class:bg-orange-400={user.client_edge.time_before_jump_racing.today <= 172859 &&
							user.client_edge.time_before_jump_racing.today >= 28860 &&
							user.client_edge.time_before_jump_racing.today !== null}
						class:bg-yellow-400={user.client_edge.time_before_jump_racing.today <= 28859 &&
							user.client_edge.time_before_jump_racing.today >= 10860 &&
							user.client_edge.time_before_jump_racing.today !== null}
						class:bg-green-300={user.client_edge.time_before_jump_racing.today <= 10859 &&
							user.client_edge.time_before_jump_racing.today >= 3660 &&
							user.client_edge.time_before_jump_racing.today !== null}
						class:bg-green-500={user.client_edge.time_before_jump_racing.today <= 3659 &&
							user.client_edge.time_before_jump_racing.today !== null}
						>{user.client_edge.time_before_jump_racing.today == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_jump_racing.today)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_jump_racing.last_2_days >= 172860 &&
							user.client_edge.time_before_jump_racing.last_2_days !== null}
						class:bg-orange-400={user.client_edge.time_before_jump_racing.last_2_days <= 172859 &&
							user.client_edge.time_before_jump_racing.last_2_days >= 28860 &&
							user.client_edge.time_before_jump_racing.last_2_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_jump_racing.last_2_days <= 28859 &&
							user.client_edge.time_before_jump_racing.last_2_days >= 10860 &&
							user.client_edge.time_before_jump_racing.last_2_days !== null}
						class:bg-green-300={user.client_edge.time_before_jump_racing.last_2_days <= 10859 &&
							user.client_edge.time_before_jump_racing.last_2_days >= 3660 &&
							user.client_edge.time_before_jump_racing.last_2_days !== null}
						class:bg-green-500={user.client_edge.time_before_jump_racing.last_2_days <= 3659 &&
							user.client_edge.time_before_jump_racing.last_2_days !== null}
						>{user.client_edge.time_before_jump_racing.last_2_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_jump_racing.last_2_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_jump_racing.last_7_days >= 172860 &&
							user.client_edge.time_before_jump_racing.last_7_days !== null}
						class:bg-orange-400={user.client_edge.time_before_jump_racing.last_7_days <= 172859 &&
							user.client_edge.time_before_jump_racing.last_7_days >= 28860 &&
							user.client_edge.time_before_jump_racing.last_7_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_jump_racing.last_7_days <= 28859 &&
							user.client_edge.time_before_jump_racing.last_7_days >= 10860 &&
							user.client_edge.time_before_jump_racing.last_7_days !== null}
						class:bg-green-300={user.client_edge.time_before_jump_racing.last_7_days <= 10859 &&
							user.client_edge.time_before_jump_racing.last_7_days >= 3660 &&
							user.client_edge.time_before_jump_racing.last_7_days !== null}
						class:bg-green-500={user.client_edge.time_before_jump_racing.last_7_days <= 3659 &&
							user.client_edge.time_before_jump_racing.last_7_days !== null}
						>{user.client_edge.time_before_jump_racing.last_7_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_jump_racing.last_7_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_jump_racing.last_30_days >= 172860 &&
							user.client_edge.time_before_jump_racing.last_30_days !== null}
						class:bg-orange-400={user.client_edge.time_before_jump_racing.last_30_days <= 172859 &&
							user.client_edge.time_before_jump_racing.last_30_days >= 28860 &&
							user.client_edge.time_before_jump_racing.last_30_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_jump_racing.last_30_days <= 28859 &&
							user.client_edge.time_before_jump_racing.last_30_days >= 10860 &&
							user.client_edge.time_before_jump_racing.last_30_days !== null}
						class:bg-green-300={user.client_edge.time_before_jump_racing.last_30_days <= 10859 &&
							user.client_edge.time_before_jump_racing.last_30_days >= 3660 &&
							user.client_edge.time_before_jump_racing.last_30_days !== null}
						class:bg-green-500={user.client_edge.time_before_jump_racing.last_30_days <= 3659 &&
							user.client_edge.time_before_jump_racing.last_30_days !== null}
						>{user.client_edge.time_before_jump_racing.last_30_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_jump_racing.last_30_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_jump_racing.last_90_days >= 172860 &&
							user.client_edge.time_before_jump_racing.last_90_days !== null}
						class:bg-orange-400={user.client_edge.time_before_jump_racing.last_90_days <= 172859 &&
							user.client_edge.time_before_jump_racing.last_90_days >= 28860 &&
							user.client_edge.time_before_jump_racing.last_90_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_jump_racing.last_90_days <= 28859 &&
							user.client_edge.time_before_jump_racing.last_90_days >= 10860 &&
							user.client_edge.time_before_jump_racing.last_90_days !== null}
						class:bg-green-300={user.client_edge.time_before_jump_racing.last_90_days <= 10859 &&
							user.client_edge.time_before_jump_racing.last_90_days >= 3660 &&
							user.client_edge.time_before_jump_racing.last_90_days !== null}
						class:bg-green-500={user.client_edge.time_before_jump_racing.last_90_days <= 3659 &&
							user.client_edge.time_before_jump_racing.last_90_days !== null}
						>{user.client_edge.time_before_jump_racing.last_90_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_jump_racing.last_90_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_jump_racing.lifetime >= 172860 &&
							user.client_edge.time_before_jump_racing.lifetime !== null}
						class:bg-orange-400={user.client_edge.time_before_jump_racing.lifetime <= 172859 &&
							user.client_edge.time_before_jump_racing.lifetime >= 28860 &&
							user.client_edge.time_before_jump_racing.lifetime !== null}
						class:bg-yellow-400={user.client_edge.time_before_jump_racing.lifetime <= 28859 &&
							user.client_edge.time_before_jump_racing.lifetime >= 10860 &&
							user.client_edge.time_before_jump_racing.lifetime !== null}
						class:bg-green-300={user.client_edge.time_before_jump_racing.lifetime <= 10859 &&
							user.client_edge.time_before_jump_racing.lifetime >= 3660 &&
							user.client_edge.time_before_jump_racing.lifetime !== null}
						class:bg-green-500={user.client_edge.time_before_jump_racing.lifetime <= 3659 &&
							user.client_edge.time_before_jump_racing.lifetime !== null}
						>{user.client_edge.time_before_jump_racing.lifetime == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_jump_racing.lifetime)}</td
					>
				</tr>
			{/if}
			{#if user.client_edge && user.client_edge.time_before_event_sport}
				<tr class="text-sm text-center bg-gray-100 italic">
					<td class="py-1 text-left border-b px-2 font-semibold text-base text-nowrap"> Time Before Event - Sport </td>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_event_sport.today >= 172860 &&
							user.client_edge.time_before_event_sport.today !== null}
						class:bg-orange-400={user.client_edge.time_before_event_sport.today <= 172859 &&
							user.client_edge.time_before_event_sport.today >= 28860 &&
							user.client_edge.time_before_event_sport.today !== null}
						class:bg-yellow-400={user.client_edge.time_before_event_sport.today <= 28859 &&
							user.client_edge.time_before_event_sport.today >= 10860 &&
							user.client_edge.time_before_event_sport.today !== null}
						class:bg-green-300={user.client_edge.time_before_event_sport.today <= 10859 &&
							user.client_edge.time_before_event_sport.today >= 3660 &&
							user.client_edge.time_before_event_sport.today !== null}
						class:bg-green-500={user.client_edge.time_before_event_sport.today <= 3659 &&
							user.client_edge.time_before_event_sport.today !== null}
						>{user.client_edge.time_before_event_sport.today == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_event_sport.today)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_event_sport.last_2_days >= 172860 &&
							user.client_edge.time_before_event_sport.last_2_days !== null}
						class:bg-orange-400={user.client_edge.time_before_event_sport.last_2_days <= 172859 &&
							user.client_edge.time_before_event_sport.last_2_days >= 28860 &&
							user.client_edge.time_before_event_sport.last_2_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_event_sport.last_2_days <= 28859 &&
							user.client_edge.time_before_event_sport.last_2_days >= 10860 &&
							user.client_edge.time_before_event_sport.last_2_days !== null}
						class:bg-green-300={user.client_edge.time_before_event_sport.last_2_days <= 10859 &&
							user.client_edge.time_before_event_sport.last_2_days >= 3660 &&
							user.client_edge.time_before_event_sport.last_2_days !== null}
						class:bg-green-500={user.client_edge.time_before_event_sport.last_2_days <= 3659 &&
							user.client_edge.time_before_event_sport.last_2_days !== null}
						>{user.client_edge.time_before_event_sport.last_2_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_event_sport.last_2_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_event_sport.last_7_days >= 172860 &&
							user.client_edge.time_before_event_sport.last_7_days !== null}
						class:bg-orange-400={user.client_edge.time_before_event_sport.last_7_days <= 172859 &&
							user.client_edge.time_before_event_sport.last_7_days >= 28860 &&
							user.client_edge.time_before_event_sport.last_7_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_event_sport.last_7_days <= 28859 &&
							user.client_edge.time_before_event_sport.last_7_days >= 10860 &&
							user.client_edge.time_before_event_sport.last_7_days !== null}
						class:bg-green-300={user.client_edge.time_before_event_sport.last_7_days <= 10859 &&
							user.client_edge.time_before_event_sport.last_7_days >= 3660 &&
							user.client_edge.time_before_event_sport.last_7_days !== null}
						class:bg-green-500={user.client_edge.time_before_event_sport.last_7_days <= 3659 &&
							user.client_edge.time_before_event_sport.last_7_days !== null}
						>{user.client_edge.time_before_event_sport.last_7_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_event_sport.last_7_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_event_sport.last_30_days >= 172860 &&
							user.client_edge.time_before_event_sport.last_30_days !== null}
						class:bg-orange-400={user.client_edge.time_before_event_sport.last_30_days <= 172859 &&
							user.client_edge.time_before_event_sport.last_30_days >= 28860 &&
							user.client_edge.time_before_event_sport.last_30_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_event_sport.last_30_days <= 28859 &&
							user.client_edge.time_before_event_sport.last_30_days >= 10860 &&
							user.client_edge.time_before_event_sport.last_30_days !== null}
						class:bg-green-300={user.client_edge.time_before_event_sport.last_30_days <= 10859 &&
							user.client_edge.time_before_event_sport.last_30_days >= 3660 &&
							user.client_edge.time_before_event_sport.last_30_days !== null}
						class:bg-green-500={user.client_edge.time_before_event_sport.last_30_days <= 3659 &&
							user.client_edge.time_before_event_sport.last_30_days !== null}
						>{user.client_edge.time_before_event_sport.last_30_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_event_sport.last_30_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_event_sport.last_90_days >= 172860 &&
							user.client_edge.time_before_event_sport.last_90_days !== null}
						class:bg-orange-400={user.client_edge.time_before_event_sport.last_90_days <= 172859 &&
							user.client_edge.time_before_event_sport.last_90_days >= 28860 &&
							user.client_edge.time_before_event_sport.last_90_days !== null}
						class:bg-yellow-400={user.client_edge.time_before_event_sport.last_90_days <= 28859 &&
							user.client_edge.time_before_event_sport.last_90_days >= 10860 &&
							user.client_edge.time_before_event_sport.last_90_days !== null}
						class:bg-green-300={user.client_edge.time_before_event_sport.last_90_days <= 10859 &&
							user.client_edge.time_before_event_sport.last_90_days >= 3660 &&
							user.client_edge.time_before_event_sport.last_90_days !== null}
						class:bg-green-500={user.client_edge.time_before_event_sport.last_90_days <= 3659 &&
							user.client_edge.time_before_event_sport.last_90_days !== null}
						>{user.client_edge.time_before_event_sport.last_90_days == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_event_sport.last_90_days)}</td
					>
					<td
						class="py-1 text-left border-b"
						class:bg-red-400={user.client_edge.time_before_event_sport.lifetime >= 172860 &&
							user.client_edge.time_before_event_sport.lifetime !== null}
						class:bg-orange-400={user.client_edge.time_before_event_sport.lifetime <= 172859 &&
							user.client_edge.time_before_event_sport.lifetime >= 28860 &&
							user.client_edge.time_before_event_sport.lifetime !== null}
						class:bg-yellow-400={user.client_edge.time_before_event_sport.lifetime <= 28859 &&
							user.client_edge.time_before_event_sport.lifetime >= 10860 &&
							user.client_edge.time_before_event_sport.lifetime !== null}
						class:bg-green-300={user.client_edge.time_before_event_sport.lifetime <= 10859 &&
							user.client_edge.time_before_event_sport.lifetime >= 3660 &&
							user.client_edge.time_before_event_sport.lifetime !== null}
						class:bg-green-500={user.client_edge.time_before_event_sport.lifetime <= 3659 &&
							user.client_edge.time_before_event_sport.lifetime !== null}
						>{user.client_edge.time_before_event_sport.lifetime == null
							? '-'
							: covertSecondsToDisplayString(user.client_edge.time_before_event_sport.lifetime)}</td
					>
				</tr>
			{/if}
		</table>
	</div>
</div>
